import ProposalHeader from './ProposalHeader';

export default ProposalHeader;
